<template>
  <div class="circle-stack"
       :class="{ collapsed: !isVisible , dragging: isDragging }"
       :style="{ left: position.x + 'px', top: position.y + 'px' }"
       @mousedown="startDrag"
  >
    <!--
    <div class="header">

      <span class="title">진행상황 통합 모니터링</span>
      <button class="toggle-btn" @click="toggleVisibility">
        {{ isVisible ? '숨기기' : '보이기' }}
      </button>

    </div>
     -->

    <transition name="slide-fade">
      <div v-if="isVisible">
        <div class="circle-grid">
          <div class="circle-item">
            <p class="label">상품수집</p>
            <ProgressBar
              :value="collectProgress"
              :color="collectColor"
              :successCount="collectSuccessCount"
              :failedCount="collectFailedCount"
              :showFinished="collectProgress > 0"
              :isFinished="socketStore.finish"
              :size="40"
              :stroke="6"
            />
          </div>
          <div class="circle-item">
            <p class="label">재고</p>
            <ProgressBar
              :value="stockProgress"
              :color="stockColor"
              :successCount="stockSuccessCount"
              :failedCount="stockFailedCount"
              :showFinished="stockProgress > 0"
              :isFinished="socketStore.finish"
              :size="40"
              :stroke="6"
            />
          </div>
          <div class="circle-item">
            <p class="label">마켓업로드</p>
            <ProgressBar
              :value="uploadProgress"
              :color="uploadColor"
              :successCount="uploadSuccessCount"
              :failedCount="uploadFailedCount"
              :showFinished="uploadProgress > 0"
              :isFinished="socketStore.finish"
              :size="40"
              :stroke="6"
            />
          </div>
          <div class="circle-item">
            <p class="label">삭제</p>
            <ProgressBar
              :value="deleteProgress"
              :color="deleteColor"
              :successCount="deleteSuccessCount"
              :failedCount="deleteFailedCount"
              :showFinished="deleteProgress > 0"
              :isFinished="socketStore.finish"
              :size="40"
              :stroke="6"
            />
          </div>
        </div>
        <!--
        <div class="global-log-box">
          <div class="log-scroll">
            <div
              v-for="(log, index) in sortedLogs"
              :key="index"
              class="log-line"
              :class="{ success: log.isSuccess, fail: !log.isSuccess }"
            >
              {{ formatTimestamp(log.timestamp) }} : {{ log.site }} {{ log.groupName }} {{ log.code }} {{ log.name }} {{ log.failReason }} {{ log.message || getFallbackMessage(log) }}
            </div>
          </div>
        </div>
        -->
      </div>
    </transition>
  </div>
</template>

<script>
//import { useSocketStore } from '@/stores/socket';
import ProgressBar from '@/components/common/ProgressBar.vue';

export default {
  name: 'ProgressBarStack',
  components: { ProgressBar },
  data() {
    const elWidth = 480;
    const windowWidth = window.innerWidth;

    return {

      isVisible: true,
      isDragging: false,
      dragOffset: { x: 0, y: 0 },
      position: {
        x: (windowWidth - elWidth) / 2,
        y: 5,
      },
    };
  },
  computed: {

    collectLogs() { return this.socketStore.collectList || []; },
    uploadLogs() { return this.socketStore.uploadList || []; },
    stockLogs() {
      const selectedServer = sessionStorage.getItem('selectedServer');
      return this.socketStore.stockLinkList
      .filter(log => String(log.serverNo) === String(selectedServer)) // 서버 번호 필터링
      .map(log => ({
        ...log,
        type: '재고',
        timestamp: log.regDate || log.timestamp || new Date()
      }))
      .sort((a, b) => b.timestamp - a.timestamp) || []; },
    deleteLogs() { return this.socketStore.deleteResultList || []; },

    mergedLogs() {


      return [
        ...this.collectLogs.map(log => ({ ...log, type: '상품수집' })),
        ...this.uploadLogs.map(log => ({ ...log, type: '마켓업로드' })),
        ...this.stockLogs.map(log => ({ ...log, type: '재고' })),
        ...this.deleteLogs.map(log => ({ ...log, type: '삭제' }))
      ]
        .map((log) => ({
          ...log,
          timestamp: log.regDate
        }))
        .sort((a, b) => b.timestamp - a.timestamp);
    },

    collectProgress() {
      const total = this.collectLogs.length;
      const success = this.collectLogs.filter(log => log.isSuccess).length;
      return total ? Math.round((success / total) * 100) : 0;
    },
    uploadProgress() {
      const total = this.uploadLogs.length;
      const success = this.uploadLogs.filter(log => log.isSuccess).length;
      return total ? Math.round((success / total) * 100) : 0;
    },
    stockProgress() {
      const validLogs = this.stockLogs.filter(log => log.isCount !== false);
      const total = validLogs.length;
      const success = validLogs.filter(log => log.isSuccess).length;
      return total ? Math.round((success / total) * 100) : 0;
    },
    deleteProgress() {
      const total = this.deleteLogs.length;
      const success = this.deleteLogs.filter(log => log.isSuccess).length;
      return total ? Math.round((success / total) * 100) : 0;
    },

    sortedLogs() {
      return [...this.mergedLogs].sort((a, b) => b.timestamp - a.timestamp);
    },

    collectSuccessCount() {
      /*this.collectLogs.forEach(log => {
        console.log('log:', log); // 로그 데이터 출력
      });*/

      return this.collectLogs.filter(log =>
        log.isSuccess &&
        (!log.message || !log.message.includes('페이지 조회')) &&
        (!log.failReason || !log.failReason.includes('페이지 조회'))
      ).length;
    },
    uploadSuccessCount() { return this.uploadLogs.filter(log => log.isSuccess).length; },
    stockSuccessCount() { return this.stockLogs.filter( log => log.isSuccess &&
      log.isCount !== false && // <-- false만 제외
      (!log.message || !log.message.includes('페이지 조회')) &&
      (!log.failReason || !log.failReason.includes('페이지 조회'))
    ).length; },
    deleteSuccessCount() { return this.deleteLogs.filter(log => log.isSuccess).length; },

    collectFailedCount() { return this.collectLogs.filter(log =>  !log.isSuccess ).length; },
    uploadFailedCount() { return this.uploadLogs.filter(log => !log.isSuccess).length; },
    stockFailedCount() { return this.stockLogs.filter(log => !log.isSuccess).length; },
    deleteFailedCount() { return this.deleteLogs.filter(log => !log.isSuccess).length; },

    collectColor() { return '#4caf50'; },
    uploadColor() { return '#2196f3'; },
    stockColor() { return '#9c27b0'; },
    deleteColor() { return '#f44336'; },
  },
  methods: {
    toggleVisibility() {
      this.isVisible = !this.isVisible;
    },
    formatTimestamp(timestamp) {
      if (!timestamp) return '';
      const date = new Date(timestamp);
      return `${(date.getUTCMonth() + 1).toString().padStart(2, '0')}-${date.getUTCDate().toString().padStart(2, '0')} ` +
        `${date.getUTCHours().toString().padStart(2, '0')}:${date.getUTCMinutes().toString().padStart(2, '0')}`;
    },
    getFallbackMessage(log) {
      const status = log.isSuccess ? '성공' : '실패';
      return `[${log.type}] ${status}`;
    },

    startDrag(event) {
      this.isDragging = true;
      this.dragOffset.x = event.clientX - this.position.x;
      this.dragOffset.y = event.clientY - this.position.y;

      document.body.style.userSelect = 'none';

      document.addEventListener('mousemove', this.onDrag);
      document.addEventListener('mouseup', this.stopDrag);
    },

    onDrag(event) {
      if (!this.isDragging) return;

      this.position.x = event.clientX - this.dragOffset.x;
      this.position.y = event.clientY - this.dragOffset.y;
    },

    stopDrag() {
      if (!this.isDragging) return;

      this.isDragging = false;
      document.body.style.userSelect = '';

      document.removeEventListener('mousemove', this.onDrag);
      document.removeEventListener('mouseup', this.stopDrag);
    },
  }
}
</script>

<style scoped lang="scss">
.circle-stack {
  top: 0px;
  left: 50%;
  position: fixed;
  background: rgba(255, 255, 255, 0.95);
  border: 1px solid #ccc;
  padding: 0px;
  border-radius: 10px;
  width: 500px;
  height: 60px;
  padding: 0px;
  z-index: 99999;
  cursor: grab;

  &.collapsed {
    width: 250px; // 숨김 상태일 때 가로폭 줄이기
  }
  &.dragging {
    cursor: grabbing;
  }

  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 11px;
    font-weight: bold;
    margin-bottom:0px;
  }

  .toggle-btn {
    background: none;
    border: none;
    font-size: 11px;
    color: #666;
    cursor: pointer;
  }

  .circle-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr); // 4개 항목이 가로로 나열
    gap: 6px;
  }

  .circle-item {
    display: flex;
    flex-direction: column;
    align-items: center;

    .label {
      font-size: 11px;
      margin-bottom: 0;
    }
  }

  .global-log-box {
    margin-top: 16px;
    padding: 2px 5px;
    background: #f8f8f8;
    border: 1px solid #ccc;
    border-radius: 6px;
    font-size: 9px;
    line-height: 1.4;
    height: 60px;
    overflow-y: auto;
    overflow-x: hidden;

    .log-line {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      margin-bottom: 0px;

      &.success {
        color: #4caf50;
      }

      &.fail {
        color: #f44336;
      }
    }
  }
}
</style>
